import { createSlice } from '@reduxjs/toolkit'

import { LANGUAGE_STORAGE_KEY } from '../../utils/language'
import { switchCompany } from './sessionActions'

const user = JSON.parse(localStorage.getItem('user'))

const initialState = { user: user ? user : {} }

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // Not initialState: that is the user stored at page load
    resetUser: () => ({ user: {} }),
    setUser: (state, action) => {
      state.user = action.payload
    },
    logout: (state) => {
      state.user = {}
      const language = localStorage.getItem(LANGUAGE_STORAGE_KEY)
      localStorage.clear()
      if (language) localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(switchCompany, (state, action) => {
      state.user = action.payload.user
    })
  },
})

export const { setUser, resetUser, logout } = userSlice.actions
export default userSlice.reducer
